import { useIsMobile } from '@/hooks/use-is-mobile';
import dynamic from 'next/dynamic';

const FilterSidebar = dynamic(() => import('./filterSidebar'), { ssr: false });

const FilterSideBarLazyLoad = props => {
  const { isDesktop } = useIsMobile();

  return isDesktop && <FilterSidebar {...props} />;
};

export default FilterSideBarLazyLoad;
